module.exports = flarum.core.compat['utils/ItemList'];